import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FilterType } from '../../interfaces/Filter.interfaces';
import { filterSlice } from '../../store/filterSlice';
import { useAppDispatch } from '../store/useStore';

export const useCheckSearchParamUpdate = ({ filterType }: { filterType: FilterType }) => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const filterActon = filterSlice.actions;

  useEffect(() => {
    const decodedSearchParams = decodeURIComponent(searchParams.toString());

    if (decodedSearchParams.length > 0) {
      dispatch(filterActon.changeIsSearchParamChecked({ filterType, value: false }));
    }
  }, [searchParams, dispatch, filterActon, filterType]);
};
